import type { ReactElement } from 'react';
import { ButtonLink } from '../ui/Button';
import { Card } from '../ui/Card';
import { IconButton } from '../ui/IconButton';
import { Stack } from '../ui/Stack';
import { dismiss } from './dismissal';

export interface AgentCardProps {
  workspaceId: string;
  userId: string | null;
}

/** Shown once steps 1 and 2 are done, until dismissed. */
export function AgentCard({ workspaceId, userId }: AgentCardProps): ReactElement {
  return (
    <Card>
      <div className="m-0 p-0 border-0 bg-transparent flex items-start justify-between gap-3">
        <Stack gap={3}>
          <p className="m-0 p-0 font-ui font-semibold text-ink">Keep it up to date: connect your agent</p>
          <div className="m-0 p-0 border-0 bg-transparent">
            <ButtonLink href={`/w/${workspaceId}/agents`}>Connect your agent</ButtonLink>
          </div>
        </Stack>
        <IconButton label="Dismiss agent card" onPress={() => (userId ? dismiss(userId, workspaceId, 'agent') : undefined)}>
          <span aria-hidden="true">×</span>
        </IconButton>
      </div>
    </Card>
  );
}
